import React, { Fragment } from 'react'
import { CardHeader } from 'reactstrap'
import { CardHeaderCommonProps } from '../../Types/CommonComponent.type'
import { H4, P } from '../../AbstractElements'

export default function CardHeaderCommon({ title, span, headClass, icon, tagClass, paraClass }: CardHeaderCommonProps) {
    return (
        <CardHeader className={headClass ? headClass : ""}>
            <H4 className={tagClass ? tagClass : ""}>{icon && icon}{title}</H4>
            {span && (
                <P className={`f-m-light mt-1 ${paraClass ? paraClass : ''}`}>
                    {span.map((data, index) => (
                        <Fragment key={index}>
                            {data?.text} {data.code && <code>{data.code}</code>} {data.mark && <mark>{data.mark}</mark>}
                        </Fragment>
                    ))}
                </P>
            )}
        </CardHeader>
    )
}
